import { configureStore } from "@reduxjs/toolkit"
import AuthReducer from "./reducers/AuthReducer"
import userReducer from "./reducers/UserReducer";
import layoutReducer from "./reducers/LayoutReducer";
import stateReducer from "./reducers/StateReducer";
import cityReducer from "./reducers/CityReducer";
import zoneReducer from "./reducers/ZoneReducer";
import userTypeReducer from "./reducers/UserTypeReducer";
import masterReducer from "./reducers/MasterReducer";
import geofenceReducer from "./reducers/GeofenceReducer";
import hospitalReducer from "./reducers/HospitalReducer";
import designationReducer from "./reducers/DesignationReducer";
import educationReducer from "./reducers/EducationReducer";
import incomeReducer from "./reducers/IncomeReducer";
import jobReducer from "./reducers/JobReducer";
import localityReducer from "./reducers/LocalityReducer";
import occupationReducer from "./reducers/OccupationReducer";
import relationshipReducer from "./reducers/RelationshipReducer";
import checklistReducer from "./reducers/ChecklistReducer";
import subChecklistReducer from "./reducers/SubChecklistReducer";
import typeOfClaimReducer from "./reducers/TypeOfClaimReducer";
import insuranceReducer from "./reducers/InsuranceReducer";
import insuranceTpaReducer from "./reducers/InsuranceTpaReducer";
import insuranceManagerReducer from "./reducers/InsuranceManagerReducer";
import roomTypeReducer from "./reducers/RoomTypeReducer";
import hospitalizationReducer from "./reducers/HospitalizationReducer";
import injuryTypeReducer from "./reducers/InjuryTypeReducer";
import generalSettingReducer from "./reducers/GeneralSettingReducer";
import userTypePermissionReducer from "./reducers/UserTypePermissionReducer";
import userPermissionReducer from "./reducers/UserPermissionReducer";
import caseDetailsReducer from "./reducers/CaseDetailsReducer";
import mapReducer from "./reducers/MapReducer";
import attendanceReducers from "./reducers/AttendanceReducers";
import callLogsReducer from "./reducers/CallLogsReducers";
import leaveReducer from "./reducers/LeaveReducer";
import dashboardReducer from "./reducers/DashboardReducer";
import insuranceMapReducer from "./reducers/InsuranceMapReducers";
import tripReportReducer from "./reducers/TripReportReducer";
import searchReducer from "./reducers/SearchReducer";
import { thunk } from 'redux-thunk';
const Store = configureStore({
        reducer: {
                AuthReducer,
                userReducer,
                layoutReducer,
                stateReducer,
                cityReducer,
                zoneReducer,
                masterReducer,
                geofenceReducer,
                userTypeReducer,
                generalSettingReducer,
                hospitalReducer,
                designationReducer,
                educationReducer,
                incomeReducer,
                jobReducer,
                localityReducer,
                occupationReducer,
                relationshipReducer,
                checklistReducer,
                subChecklistReducer,
                typeOfClaimReducer,
                userTypePermissionReducer,
                userPermissionReducer,
                insuranceReducer,
                insuranceTpaReducer,
                insuranceManagerReducer,
                roomTypeReducer,
                hospitalizationReducer,
                injuryTypeReducer,
                caseDetailsReducer,
                mapReducer,
                attendanceReducers,
                callLogsReducer,
                leaveReducer,
                dashboardReducer,
                insuranceMapReducer,
                tripReportReducer,
                searchReducer,
        },
        middleware: (getDefaultMiddleware) =>
                getDefaultMiddleware().concat(thunk),
})

export default Store